import { render } from "./DefaultCultureSelector.vue?vue&type=template&id=4cd06578"
import script from "./DefaultCultureSelector.vue?vue&type=script&lang=js"
export * from "./DefaultCultureSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__